// extracted by mini-css-extract-plugin
export default {"main":"Notes_main__jIjN7","loadingState":"Notes_loadingState__R0bA0","list":"Notes_list__xnyKd"};